export default {
  userNetworkShares: [],
}
